import { render, staticRenderFns } from "./SparepartsDialogForm.vue?vue&type=template&id=5c4d91a5&"
import script from "./SparepartsDialogForm.vue?vue&type=script&lang=js&"
export * from "./SparepartsDialogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports